

    import Vue from "vue";
    import ApiButton from "@/components/ApiButton.vue";
    import Component from "vue-class-component";
    import "leaflet/dist/leaflet.css";
    import L, { LatLng, Icon } from "leaflet";
    import { ApiClient } from "@/utilities/ApiClient";
    import { LMap, LTileLayer, LMarker, LPopup, LIcon, LTooltip } from "vue2-leaflet";
    import { Utils } from "@/utilities/Utils";
    import * as toastr from "toastr";
    import { IPostcodeData, PostcodeData } from "@/model/PostcodeData";
    import { IBooking, Booking } from "@/model/Booking";
    import { IHereLocation, HereLocation } from "@/model/HereLocation";

    @Component({
        components: { 
            ApiButton,
            LMap,
            LTileLayer,
            LMarker,
            LPopup,
            LIcon,
            LTooltip
        }
    })

    export default class BookingMapModal extends Vue {

        //
        // -- properties
        //

        bookingID: number = 0;
        booking: Booking = new Booking();
        bookingPostCode: string = "";
        postcode: string = "";
        private searchOptions: Array<string> = ["Postcode", "what3words"];
        private searchOption = "Postcode";
        hereLocationData: HereLocation = new HereLocation();
        
        // map properties
        // showMap: boolean = true;
        // zoom: number = 12;
        // center = new LatLng(55.3781, 3.4360);
        // url: string = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
        // jobLocation = new LatLng(55.3781, 3.4360);

        showMap: boolean = true;
        zoom: number = 4;
        center = new LatLng(53.42157465935719, -2.7321959298803455);
        url: string = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
        bounds: null = null;
        attribution: string = '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors';
        markers: any = [];

        //
        // -- methods
        //

        async show(bookingID: number) {
            this.bookingID = 0;
            this.bookingID = bookingID;
            this.renderMap(bookingID);
        }

        async renderMap(id: number) {
            this.$bvModal.show("bookingMapModal");
            this.forceRerender();
            console.log(this.bookingID)
             if (this.bookingID != 0) {
                const bookingData = await ApiClient.get(`api/booking/GetBooking?id=${this.bookingID}`);
                this.booking.update(bookingData);
                this.markers = [];
                var center = new LatLng(this.booking.worksLatitude, this.booking.worksLongitude);
                var test = this.$refs.map as LMap; 
                var map = test.mapObject; 
                map.setView(center, 14);
                this.markers.push(new LatLng(this.booking.worksLatitude, this.booking.worksLongitude));
            }
            // this.jobLocation = new LatLng(locationData.latitude, locationData.longitude);
        }

        addMarker(event: any) {
            if (event.detail === 2) {
                toastr.success("Double Click");
                return;
            }
            // this.markers.push(event.latlng);
             var popup = L.popup({closeButton: false});
            var test = this.$refs.map as any; 
            var map = test.mapObject;
            var id = Math.floor(Math.random()*(999-100+1)+100);
            popup.setLatLng(event.latlng);
            if (this.markers.length > 0) {
                popup.setContent(`<button @click="searchPostcode()" id="setLocation${id}">Change Location</button>`);
            }
            else {
                popup.setContent(`<button @click="searchPostcode()" id="setLocation${id}">Add Location</button>`);
            }
            popup.addTo(map);
            popup.openOn(map);
            var doc = document.getElementById(`setLocation${id}`);
            if (doc != null)
            doc.addEventListener('click', (e) => {
                popup.remove();
                this.addLocation(event.latlng);
            });
        }

        addLocation(latlng: LatLng) {
            this.markers = [];
            this.markers.push(latlng);
        }

        async confirmLocation() {
            console.log(this.hereLocationData);
            var latlng = this.markers[0];
            if (this.hereLocationData != null) {
                if (latlng.lat == this.hereLocationData.position.lat && latlng.lng == this.hereLocationData.position.lng) {
                    this.booking.worksWhatThreeWords = this.hereLocationData.what3Words;
                    this.booking.worksPlaceName = `${this.hereLocationData.address.district}, ${this.hereLocationData.address.city}`;
                }
                else {
                    const response: HereLocation = await ApiClient.get(`api/booking/locationFromLatLng?lat=${latlng.lat}&lng=${latlng.lng}`);
                    if (response == null) {
                        toastr.error("There was an issue whilst retrieving the location data.")
                        return;
                    }
                    this.booking.worksWhatThreeWords = response.what3Words;
                    this.booking.worksPlaceName = `${response.address.district}, ${response.address.city}`;
                }
            }
            else {
                const response: HereLocation = await ApiClient.get(`api/booking/locationFromLatLng?lat=${latlng.lat}&lng=${latlng.lng}`);
                if (response == null) {
                        toastr.error("There was an issue whilst retrieving the location data.")
                        return;
                    }
                this.booking.worksWhatThreeWords = response.what3Words;
                this.booking.worksPlaceName = `${response.address.district}, ${response.address.city}`;
            }
            if (this.booking.id != 0) {
                this.booking.worksLatitude = latlng.lat;
                this.booking.worksLongitude = latlng.lng;
                await ApiClient.post("/Api/Booking/SaveBooking", this.booking, event);
                toastr.success("Location Saved");
                this.$emit("saved");
                this.$bvModal.hide("bookingMapModal");
            }
            else {
                this.$emit("updateLatLng", latlng.lat, latlng.lng, this.booking.worksWhatThreeWords, this.booking.worksPlaceName);
                this.$bvModal.hide("bookingMapModal");
            }
        }

        forceRerender() {
            setTimeout(() => { window.dispatchEvent(new Event('resize')) }, 250);
        }

        cancel() {
            this.$bvModal.hide("bookingMapModal");
        }

        async searchMap() {
            if (this.searchOption == "Postcode") {
                await this.searchPostcode();
            }
            if (this.searchOption == "what3words") {
                await this.what3WordsToLatLng();
            }
            else {
                return;
            }
        }

        async searchPostcode() {
            const locationData: PostcodeData = await ApiClient.get(`api/booking/GetPostCodeData?postcode=${this.postcode}`);
            if (locationData != null) {
                var center = new LatLng(parseFloat(locationData.latitude), parseFloat(locationData.longitude));
                var test = this.$refs.map as LMap; 
                var map = test.mapObject; 
                map.setView(center, 14);
                this.addLocation(center);
            }
            else {
                toastr.warning("Postcode not found! Please enter manually");
            }
        }

        async what3WordsToLatLng() {
            const response = await ApiClient.get(`api/booking/What3WordsToLatLng?threeWords=${this.postcode}`);
            // this.hereLocationData.update(response);
            var center = new LatLng(response.coordinates.lat, response.coordinates.lng);
            var test = this.$refs.map as LMap; 
            var map = test.mapObject; 
            map.setView(center, 14);
            this.addLocation(center);
        }
    }

